var Curriculog = Curriculog || {};
Curriculog.ProposalForm = Curriculog.ProposalForm || {};

Curriculog.ProposalForm.TextField = (function ($, _, Backbone, TextField) {

	TextField = Curriculog.ProposalForm.Field.extend({

		/**
		 * Prevent the enter key from saving fields higher in the DOM
		 *
		 * @param   {Event} event - the key event
		 */
		onKeypress: function(event) {
			Curriculog.ProposalForm.Field.prototype.onKeypress.apply(this, arguments);
			// Intercept the ENTER key and save the field.
			// If we dont prevent this from bubbling, any save (submit) button higher in the
			// dom will catch the event and save their field.
			var ENTER_KEY = 13;
			if (event.which !== ENTER_KEY) {
				return;
			}

			this.stopEvent(event);
			// check to make sure field is currently being edited and user is not
			// trying to cancel edit
			if (this.proposal.get('status') != 'unlaunched' && this.mode === 'edit' && $(event.target).hasClass('cancel-field') === false ) {
				this.save();
			}
		},

		/**
		 * Used to return the value of the field
		 *
		 * @returns {String}
		 */
		getValue: function() {
			var $input = this.getInput();

			if (this.model.get('showMarkup')) {
				return this.model.get('value');
			}

			if (this.mode == 'edit') {
				return $input.val();
			}

			return _.unescape($input.html());
		},

		detectChanges: function(){
			this._unsaved_changes = $('<div />').html(this.getValue()).text().trim() != this.model.get('value');

			// highlight the field if it has unsaved changes
			if (this._unsaved_changes) {
				this.$el.addClass('field-unsaved');
			} else {
				this.$el.removeClass('field-unsaved');
			}


		},

		/**
		 * Used to set the value of the field
		 *
		 * @param {String} value - the new value
		 */
		setValue: function(value) {
			var $input = this.getInput();

			if (this.mode == 'edit') {
				return $input.val(value);
			}

			return $input.html(value);
		},

		/**
		 * Refocuses the text field after switching to edit mode
		 *
		 * @returns {promise}
		 */
		afterEdit: function() {
			this.getInput().focus();
			return Curriculog.ProposalForm.Field.prototype.afterEdit.apply(this, arguments);
		}

	});

	return TextField;

})($, _, Backbone, Curriculog.ProposalForm.TextField || {});
